import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { ONBOARDING_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IOnboardingQuestionnaireAgreement } from '../../../../../pages/questionnaires/onboarding/components/forms/agreement/types';
import type { UpdateOnboardingQuestionnaireAgreementPayload } from './types';

export function createOnboardingAgreementThunks() {
  return {
    updateOnboardingQuestionnaireAgreement: updateOnboardingQuestionnaireAgreement(),
  };
}

function updateOnboardingQuestionnaireAgreement() {
  return createAsyncThunk<
    IOnboardingQuestionnaireAgreement,
    UpdateOnboardingQuestionnaireAgreementPayload
  >(
    'onboardingQuestionnaire/updateOnboardingQuestionnaireAgreement',
    async ({ onboardingQuestionnaireId, data, getAccessTokenSilently }) => {
      const response: IOnboardingQuestionnaireAgreement = await fetchWrapper.patch(
        {
          url: `${ONBOARDING_QUESTIONNAIRES_API_BASE}/${onboardingQuestionnaireId}/agreement`,
          getAccessTokenSilently,
        },
        data,
      );
      return response;
    },
  );
}
